import {
  DRAFTER_CHEFS,
  DRAFTER_MODELS,
  drafterModel,
} from "apprentices/worker/models";
import { CheckIcon } from "lucide-react";
import { useState } from "react";

import {
  ModelSelector,
  ModelSelectorContent,
  ModelSelectorEmpty,
  ModelSelectorGroup,
  ModelSelectorInput,
  ModelSelectorItem,
  ModelSelectorList,
  ModelSelectorLogo,
  ModelSelectorName,
  ModelSelectorTrigger,
} from "@/components/ai-elements/model-selector";
import { PromptInputButton } from "@/components/ai-elements/prompt-input";

export function DrafterModelPicker({
  value,
  onChange,
  disabled = false,
}: {
  value: string;
  onChange?: (modelId: string) => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const selected = drafterModel(value);
  return (
    <ModelSelector open={open} onOpenChange={setOpen}>
      <ModelSelectorTrigger asChild disabled={disabled || !onChange}>
        <PromptInputButton aria-label="Model">
          <ModelSelectorLogo provider={selected?.chefSlug ?? "anthropic"} />
          <ModelSelectorName>{selected?.label ?? value}</ModelSelectorName>
        </PromptInputButton>
      </ModelSelectorTrigger>
      <ModelSelectorContent>
        <ModelSelectorInput placeholder="Search models..." />
        <ModelSelectorList>
          <ModelSelectorEmpty>No models found.</ModelSelectorEmpty>
          {DRAFTER_CHEFS.map((chef) => (
            <ModelSelectorGroup heading={chef} key={chef}>
              {DRAFTER_MODELS.filter((model) => model.chef === chef).map(
                (model) => (
                  <ModelSelectorItem
                    key={model.id}
                    value={model.id}
                    onSelect={() => {
                      onChange?.(model.id);
                      setOpen(false);
                    }}
                  >
                    <ModelSelectorLogo provider={model.chefSlug} />
                    <ModelSelectorName>{model.label}</ModelSelectorName>
                    {value === model.id ? (
                      <CheckIcon className="ml-auto size-4" />
                    ) : (
                      <div className="ml-auto size-4" />
                    )}
                  </ModelSelectorItem>
                ),
              )}
            </ModelSelectorGroup>
          ))}
        </ModelSelectorList>
      </ModelSelectorContent>
    </ModelSelector>
  );
}
